import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Utils from '../../../../util';
import {API} from "../../../../config";

const moment = require('moment');

const wallet = API.service('wallet');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    }
});

class Statement extends Component {
    state={
        wallet:[]
    };

    getWallet = () => {
        const app = this;
        wallet.find({query:{_account:this.props.investor._account,_currency:this.props.currency,$sort:{_timestamp:1}}}).then(s=>{
            //s.data = s.data.reverse();
            let b = 0;
            s.data.forEach((v,i)=> {
                v._balance = b + parseFloat(v._fund);
                b = b + parseFloat(v._fund);
            });
            s.data = s.data.reverse();
            app.setState({
                wallet:s.data
            })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.currency !== this.props.currency || prevProps.investor._account !== this.props.investor._account) {
            this.getWallet()
        }
    }

    timer = null;

    componentDidMount() {
        const app = this;
        this.getWallet()

        this.timer = setInterval(function(){
            app.getWallet()
        },3000)
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        const {classes} = this.props;
        let currency = Utils.getCurrency(this.props.currency.toUpperCase());

        return (
            <React.Fragment>
                <table className={'w-full'} style={{marginTop:'20px'}}>
                    <tr className={classes.tableHead}>
                        <td className={'text-center'}>Date</td>
                        <td className={'pl-2'}>Description</td>
                        <td className={'pl-2'}>Type</td>
                        <td className={'text-center pl-2'}>Change</td>
                        <td className={'text-center pl-2'}>Balance</td>
                    </tr>
                {this.state.wallet.map((v,i)=>{
                    return (
                        <tr className={classes.tableRow}>
                            <td>{moment(v._timestamp).format('L')}</td>
                            <td className={'pl-2'}>{v._comment}</td>
                            <td className={'pl-2'}>{v._type}</td>
                            <td className={'text-right pl-2'}>{currency.currency_symbol}{Utils.addThousandCommas(v._fund, '0,0.00')}</td>
                            <td className={'text-right pl-2'}>{currency.currency_symbol}{Utils.addThousandCommas(v._balance, '0,0.00')}</td>
                        </tr>
                    )
                })}
                </table>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(Statement)));
